export default __webpack_public_path__ + "static/media/Mayowa Adeojo.7b028a81.jpeg";